export default {
  app: 'APP_RECOVER',
  api: 'https://www.uat.researchfollowapp.com/portal'
};
